/** Which department a referenced cue belongs to */
export type CueDepartment = 'lx' | 'sq' | 'fs' | 'deck' | 'fly' | 'av';

/** Anchor that pins a referenced cue to a specific word in a ScriptBlock */
export interface CueAnchor {
    id: string;
    cueType: CueDepartment;
    sourceId: string;        // ID of the cue in its home module
    blockId: string;         // ScriptBlock.id
    charOffset: number;      // Character offset into ScriptBlock.text
    contextSnippet: string;  // ~20 chars surrounding the anchor for fuzzy re-matching
    sortOrder: number;       // Display order when multiple cues anchor to the same word
}

/** Custom cue types created directly in the Prompt Book */
export type CustomCueType = 'standby' | 'warning' | 'note';

/** SM-created annotation (standby, warning, or freeform note) */
export interface CustomCue {
    id: string;
    type: CustomCueType;
    label: string;            // Freeform text (e.g. "STBY LX Q15, SQ 20")
    linkedCueIds?: string[];  // Optional CueAnchor IDs (for Standbys)
    blockId: string;
    charOffset: number;
    contextSnippet: string;
    sortOrder: number;
    deleted?: boolean;
    deletedAt?: number;
}

/** Filter state for the cue type toggles */
export interface PromptBookFilters {
    lx: boolean;
    sq: boolean;
    fs: boolean;
    deck: boolean;
    fly: boolean;
    av: boolean;
}

/** View density setting */
export type ViewDensity = 'compact' | 'expanded';

/** Text scale stops (25% increments from 50% to 200%) */
export const TEXT_SCALE_STOPS = [0.5, 0.75, 1.0, 1.25, 1.5, 1.75, 2.0] as const;
export const TEXT_SCALE_DEFAULT = 1.0;
export const TEXT_SCALE_MIN = TEXT_SCALE_STOPS[0];
export const TEXT_SCALE_MAX = TEXT_SCALE_STOPS[TEXT_SCALE_STOPS.length - 1]!;

